export default __webpack_public_path__ + "static/media/niubiz_payment.6e709dc2.jpeg";